import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function ArticleSection() {
  const displayArticles = seoArticles.slice(0, 9);

  return (
    <section id="artykuly" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-xs md:text-sm text-foreground-400 tracking-widest font-medium italic">
            / Artykuły SEO
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
            Nasze Artykuły
            <br />
            <span className="italic font-normal text-foreground-600">i Poradniki</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-4 max-w-xl mx-auto">
            Poznaj nasze szczegółowe artykuły i poradniki. Od porównań platform, przez tutoriale zakupowe, po przewodniki bezpieczeństwa.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group flex flex-col rounded-2xl bg-background-100 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-[10px] md:text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-200/50">
                  <span className="text-[11px] md:text-xs text-foreground-400">{article.date}</span>
                  <span className="text-[11px] md:text-xs text-foreground-400">{article.readTime} czytania</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Link to existing detailed article */}
        <div className="text-center mt-10">
          <Link
            to="/artykul/najlepszy-kakobuy-spreadsheet-2026"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer group"
          >
            Zobacz pełny przewodnik: Najlepszy Kakobuy Spreadsheet 2026
            <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}